const getPageType = (pathname: string): string => {
  const cleanPath = pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/'); // Remove locale prefix

  if (cleanPath === '/' || cleanPath === '') return 'home';
  if (cleanPath.startsWith('/account')) return 'account';
  if (cleanPath.startsWith('/cart')) return 'cart';
  if (cleanPath.startsWith('/checkout')) return 'checkout';
  if (cleanPath.startsWith('/orders')) return 'orders';
  if (cleanPath.startsWith('/product')) return 'product';
  if (cleanPath.startsWith('/plans')) return 'plans';
  if (cleanPath.startsWith('/myrituals')) return 'app';
  if (cleanPath.startsWith('/app')) return 'app';
  if (cleanPath.startsWith('/configurator')) return 'configurator';
  if (cleanPath.startsWith('/booking')) return 'booking';
  if (cleanPath.startsWith('/experiences')) return 'experiences';
  if (cleanPath.startsWith('/magazine')) return 'magazine';
  if (cleanPath.startsWith('/faq')) return 'faq';

  return 'other';
};

export default getPageType;
